import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function AddItemForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(id ? true : false);
  const [mainCategories, setMainCategories] = useState([]);
  const [ingredients, setIngredients] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [vat, setVat] = useState([]);
  const [vendors, setVendors] = useState([]);
  // const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    code: "",
    name: "",
    name_arabic: "",
    category_id: "",
    sub_category_id: "",
    description: "",
    sale_price: "",
    tax_method: "inclusive",
    kot_print: "yes",
    is_vendor: "no",
    vendor_id: "",
    vat_id: "",
    user_id: "",
    outlet_id: "",
    veg_item: "no",
    beverage_item: "no",
    bar_item: "no",
    stock: "enable",
    is_new: "yes",
    is_tax_fix: "no",
  });
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState("No file chosen");
  const [photo, setPhoto] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let formToSubmit = new FormData();

    const payload = { ...formData };
    Object.keys(payload).forEach((key) => {
      if (payload[key] === "null") {
        payload[key] = null;
      }
    });

    formToSubmit.append("code", payload.code || "");
    formToSubmit.append("name", payload.name || "");
    formToSubmit.append("name_arabic", payload.name_arabic || "");
    formToSubmit.append("category_id", payload.category_id || "");
    if (payload.sub_category_id)
      formToSubmit.append("sub_category_id", payload.sub_category_id);
    formToSubmit.append("description", payload.description || "");
    formToSubmit.append("sale_price", payload.sale_price || "");
    formToSubmit.append("tax_method", payload.tax_method || "");
    formToSubmit.append("kot_print", payload.kot_print || "");
    formToSubmit.append("is_vendor", payload.is_vendor || "");
    formToSubmit.append("vendor_id", payload.vendor_id || "");
    formToSubmit.append("vat_id", payload.vat_id || "");
    formToSubmit.append("user_id", user?.user.id);
    formToSubmit.append("outlet_id", user?.user.outlet_id);
    formToSubmit.append("veg_item", payload.veg_item || "");
    formToSubmit.append("beverage_item", payload.beverage_item || "");
    formToSubmit.append("bar_item", payload.bar_item || "");
    formToSubmit.append("stock", payload.stock || "");
    formToSubmit.append("is_new", payload.is_new || "");
    formToSubmit.append("is_tax_fix", payload.is_tax_fix || "");
    if (photo) formToSubmit.append("photo", photo);

    selectedIngredients.forEach((item, index) => {
      formToSubmit.append(
        `ingredients[${index}][ingredient_id]`,
        item.ingredient_id
      );
      formToSubmit.append(
        `ingredients[${index}][consumption]`,
        item.consumption
      );
    });

    const postData = (csrfToken) => {
      if (!id) {
        axios
          .post(`${apiKey}/api/rms/admin/foodMenus`, formToSubmit, {
            headers: {
              Authorization: `Bearer ${user?.token}`,

              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            Object.keys(err.response.data.data).forEach((item) => {
              err.response.data.data[item].forEach((i) => {
                toast.error(i || "Validation Error");
              });
            });
          })
          .finally(() => setLoading(false));
      } else {
        axios
          .post(
            `${apiKey}/api/rms/admin/foodMenus/${id}?_method=PUT`,
            formToSubmit,
            {
              headers: {
                Authorization: `Bearer ${user?.token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            Object.keys(err.response.data.data).forEach((item) => {
              err.response.data.data[item].forEach((i) => {
                toast.error(i || "Validation Error");
              });
            });
          })
          .finally(() => setLoading(false));
      }
    };

    handleCSRF(postData);
  };

  const handleIngredientSelect = (selectedOptions) => {
    setSelectedIngredients((prevSelectedIngredients) => {
      const newSelectedIngredients = selectedOptions.map((option) => {
        const existing = prevSelectedIngredients.find(
          (ing) => ing.value === option.value
        );
        return existing || { ...option, consumption: "" }; // Keep existing consumption or initialize
      });
      return newSelectedIngredients;
    });
  };

  const handleConsumptionChange = (index, value) => {
    setSelectedIngredients((prevIngredients) => {
      const updatedIngredients = [...prevIngredients];
      updatedIngredients[index].consumption = value;
      return updatedIngredients;
    });
  };

  const consumptionComponent = (unit, index) => (
    <div className="flex" key={index}>
      <input
        type="text"
        placeholder="Consumption"
        value={selectedIngredients[index]?.consumption || ""}
        onChange={(e) => handleConsumptionChange(index, e.target.value)}
        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"
      />
      <span className="text-sm text-d-bg-text py-3 mx-2">{unit}</span>
    </div>
  );

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const methodOptions = [
    { label: languageHelper("Exclusive"), value: "exclusive" },
    { label: languageHelper("Inclusive"), value: "inclusive" },
  ];

  const chooseOptions = [
    { label: languageHelper("No"), value: "no" },
    { label: languageHelper("Yes"), value: "yes" },
  ];
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMainCat = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/admin/categories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchVat = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/admin/vats`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchIngredients = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/admin/ingredients`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchVendors = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/admin/vendor`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchItem = () => {
      if (id) {
        return axios.get(`${apiKey}/api/rms/admin/foodMenus/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        });
      }
    };

    const fetchData = (csrfToken) => {
      Promise.all([
        fetchMainCat(csrfToken),
        fetchVat(csrfToken),
        fetchIngredients(csrfToken),
        fetchVendors(csrfToken),
        fetchItem(csrfToken),
      ])
        .then(
          ([
            mainCatResponse,
            vatResponse,
            ingredientResponse,
            vendorResponse,
            itemResponse,
          ]) => {
            const mappedCategories = mainCatResponse.data.map((item) => ({
              value: item.id,
              label:
                defaultLang === "text_en"
                  ? item.category_name
                  : item.cat_name_arabic,
            }));
            setMainCategories(mappedCategories);
            const mappedVat = vatResponse.data.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            setVat(mappedVat);
            const mappedIngredients = ingredientResponse.data.map((item) => ({
              value: item.id,
              ingredient_id: item.id,
              label: item.name,
              unit: item.unit_name,
            }));
            setIngredients(mappedIngredients);
            const mappedVendors = vendorResponse.data.map((item) => ({
              value: item.id,
              label: item.vendor_name,
            }));
            setVendors(mappedVendors);
            setFormData(itemResponse.data);
            const mappedIng = itemResponse.data.ingredients.map((item) => ({
              value: item.ingredient_id,
              ingredient_id: item.ingredient_id,
              label:
                defaultLang === "text_en"
                  ? item.ingredient.name
                  : item.ingredient.name_arabic,
              unit: item.ingredient.ingredient_unit?.name,
              consumption: item.consumption,
            }));
            setSelectedIngredients(mappedIng);
          }
        )
        .catch((err) => {
          // setError(err.message);
          console.log(err);
        })
        .finally(() => setPageLoading(false));
    };

    handleCSRF(fetchData);
  }, [id, user?.token, user?.user.outlet_id]);

  useEffect(() => {
    if (formData.category_id) {
      const fetchSubCat = (csrfToken) => {
        axios
          .get(`${apiKey}/api/rms/admin/subCategories`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
            params: {
              category_id: formData.category_id,
            },
          })
          .then((res) => {
            const mappedSubCategories = res.data.map((item) => ({
              value: item.id,
              label:
                defaultLang === "text_en"
                  ? item.sub_category_name
                  : item.sub_category_name_arabic,
            }));
            setSubCategories(mappedSubCategories);
          })
          .catch((err) => {
            console.log(err);
          });
      };
      handleCSRF(fetchSubCat);
    }
  }, [formData.category_id, user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Add Item")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="grid grid-cols-3 gap-x-8 gap-y-4">
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Name")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Name")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Name Arabic")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Name Arabic")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="name_arabic"
                    value={formData.name_arabic}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative ">
                  {languageHelper("Code")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Code")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Category")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={mainCategories}
                    name="category_id"
                    defaultValue={{
                      value: formData.category_id,
                      label: formData.category?.category_name,
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        category_id: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative">
                  {languageHelper("Sub Category")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    placeholder={languageHelper("Select")}
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="sub_category_id"
                    options={subCategories}
                    defaultValue={{
                      value: formData.sub_category_id,
                      label: formData.sub_category?.sub_category_name,
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        sub_category_id: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Ingredient Consumptions")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    isMulti
                    options={ingredients}
                    defaultValue={selectedIngredients}
                    closeMenuOnSelect={false}
                    name="category_id"
                    onChange={handleIngredientSelect}
                  />
                </div>
              </label>

              <div className="relative overflow-x-auto col-span-3">
                <table className="w-full text-sm text-left rtl:text-right">
                  <thead className="uppercase font-medium">
                    <tr>
                      <th className="px-6 py-3">{languageHelper("SN")}</th>
                      <th className="px-6 py-3">
                        {languageHelper("Ingredient")}
                      </th>
                      <th className="px-6 py-3">
                        {languageHelper("Consumption")}
                      </th>
                      {/* <th className="px-6 py-3">Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {selectedIngredients.map((ingredient, index) => (
                      <tr key={index}>
                        <td className="px-6 py-1">{index + 1}</td>
                        <td className="px-6 py-1">{ingredient.label}</td>
                        <td className="px-6 py-1">
                          {consumptionComponent(ingredient.unit, index)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Sale Price")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Sale Price")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="sale_price"
                    value={formData.sale_price}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Tax Method")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={methodOptions}
                    defaultValue={{
                      value: formData.tax_method,
                      label:
                        formData.tax_method === "inclusive"
                          ? languageHelper("Inclusive")
                          : formData.tax_method === "exclusive"
                            ? languageHelper("Exclusive")
                            : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        tax_method: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative ">
                  {languageHelper("Tax Type(VAT)")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="  placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={vat}
                    defaultValue={{
                      value: formData.vat_id,
                      label: formData.vat?.name,
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        vat_id: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative">
                  {languageHelper("Is it Veg Item?")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={chooseOptions}
                    defaultValue={{
                      value: formData.veg_item,
                      label:
                        formData.veg_item === "no"
                          ? languageHelper("No")
                          : formData.veg_item === "yes"
                            ? languageHelper("Yes")
                            : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        veg_item: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative ">
                  {languageHelper("Is it Beverage?")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={chooseOptions}
                    defaultValue={{
                      value: formData.beverage_item,
                      label:
                        formData.veg_item === "no"
                          ? languageHelper("No")
                          : formData.veg_item === "yes"
                            ? languageHelper("Yes")
                            : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        beverage_item: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative ">
                  {languageHelper("Is Tax Fix?")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={chooseOptions}
                    defaultValue={{
                      value: formData.is_tax_fix,
                      label:
                        formData.veg_item === "no"
                          ? languageHelper("No")
                          : formData.veg_item === "yes"
                            ? languageHelper("Yes")
                            : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        is_tax_fix: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative">
                  {languageHelper("Is it Bar Item?")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={chooseOptions}
                    defaultValue={{
                      value: formData.bar_item,
                      label:
                        formData.veg_item === "no"
                          ? languageHelper("No")
                          : formData.veg_item === "yes"
                            ? languageHelper("Yes")
                            : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        bar_item: e.value,
                      })
                    }
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Kot Print")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={chooseOptions}
                    defaultValue={{
                      value: formData.kot_print,
                      label:
                        formData.kot_print === "no"
                          ? languageHelper("No")
                          : formData.kot_print === "yes"
                            ? languageHelper("Yes")
                            : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        kot_print: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Is Vendor?")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder={languageHelper("Select")}
                    options={chooseOptions}
                    defaultValue={{
                      value: formData.is_vendor,
                      label:
                        formData.is_vendor === "no"
                          ? languageHelper("No")
                          : formData.is_vendor === "yes"
                            ? languageHelper("Yes")
                            : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        is_vendor: e.value,
                      })
                    }
                  />
                </div>
              </label>

              {formData.is_vendor === "yes" && (
                <label htmlFor="">
                  <span className="text-d-bg-text text-sm mb-2 relative">
                    {languageHelper("Vendor Name")}
                  </span>
                  <div className="mb-2 pt-0">
                    <Select
                      type="text"
                      className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                      placeholder={languageHelper("Select")}
                      options={vendors}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          vendor_id: e.value,
                        })
                      }
                      defaultValue={{
                        value: formData.vendor_id,
                        label: formData.vendor?.vendor_name,
                      }}
                    />
                  </div>
                </label>
              )}

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative">
                  {languageHelper("Description")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    type="text"
                    placeholder={languageHelper("Description")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <div htmlFor="" className="w-full pt-5">
                <div className="flex flex-row items-center">
                  <input
                    type="file"
                    id="upload-img"
                    onChange={(e) => {
                      setSelectedPhoto(e.target.files[0].name);
                      setPhoto(e.target.files[0]);
                    }}
                    hidden
                  />
                  <label
                    htmlFor="upload-img"
                    className="block text-sm text-white mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-d-cat-btn cursor-pointer"
                  >
                    {languageHelper("Choose File")}
                  </label>
                  <label className="text-sm text-slate-500">
                    {selectedPhoto}
                  </label>
                </div>
              </div>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddItemForm;
